export const chartStatus: Readonly<any> = {
    0: { description: 'Waiting' },
    1: { description: 'Running' },
    2: { statusClass: 'orangeCircle', description: 'Abandoned' },
    3: { statusClass: 'redCircle', description: 'Failed' },
    4: { statusClass: 'orangeCircle', description: 'Waiting For User' },
    5: { statusClass: 'greenCircle', description: 'Done' },
    6: { statusClass: 'orangeCircle', description: 'Complete With Warnings' },
    7: { statusClass: 'orangeCircle', description: 'Aborting' }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/chartStatus.ts